import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toastSuccess, toastError } from "../../../../../customComponents/customToast/Toast";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import FormRange from "react-bootstrap/esm/FormRange";


const AddNewDesignation = () => {

  const businessPartnerId = localStorage.getItem("business_partner_id")
  const [loading, setLoading] = useState(false);
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const [Required,setRequired] = useState(false)
console.log("Required>>>",Required);


  const [formData, setFormData] = useState({});
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [designationInputs, setDesignationInputs] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");


  const DesignationInputsTemplate = [
    // ...(userType === "superadmin"
    //   ? [
    //       {
    //         name: "business_partner_id",
    //         label: "Business Partner",
    //         type: "dropdown",
    //         required: true,
    //         options: [],
    //         gridClass: "col-lg-4",
           
    //       },
    //     ]
    //   : []),
    {
      name: "designationlevel",
      label: "Role",
      type: "dropdown",
      required: true,
      gridClass: "col-lg-4",
      options: designationInputs,
    },
    {
      name: "designationName",
      label: "Designation Name",
      type: "text",
      placeholder:"Enter Designation Name",
      required: true,
      gridClass: "col-lg-4",
       validation: { required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      maxLength:20
     },
    },
    {
      name: "description",
      label: "Description",
      placeholder:"Enter Designation Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
     
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "parentDesignation",
    //   label: "Parent Designation",
    //   type: "dropdown",
    //   gridClass: "col-lg-4",
    //   isVisible: false, 
    //   required:Required,
    //   validation:{required:true},
    //   options: [],
    // },
  ];

    useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        business_partner_id: businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setDesignationInputs(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };


  // useEffect(() => {
  //   const fetchData = async () => {
  //     await fetchDesignationLevels();
  //     await userTypedropdown();
  //   };
  //   fetchData();
  // }, []);
  // useEffect(()=>{
  //   if(formData?.business_partner_id){
  //     setFormData({...formData,designationlevel:''})
  //     fetchDesignationLevels()
  //   }
   
  // },[formData?.business_partner_id])

  // const fetchDesignationLevels = async () => {
  //   try {

  //     const response = await axiosInstance.post(
  //       "/designation/ddldesignationlevel",{
  //         business_partner_id:userType=="superadmin"?formData?.business_partner_id:businessPartnerId
  //       }
  //       ,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );
  //     const options = response.data.data.data.map((level) => ({
  //       label: level.level,
  //       value: level.id,
  //     }));
  //     const updatedInputs = designationInputs.map((input) =>
  //       input.name === "designationlevel" ? { ...input, options } : input
  //     );
  //     setDesignationInputs(updatedInputs);
  //   } catch (error) {
  //     console.error("Error fetching designation levels:", error);
  //   }
  // };



//   useEffect(() => {
//     setFormData({...formData,parentDesignation:''})
//     const fetchParentDesignations = async (designationLevelId) => {
//       if (!formData.designationlevel) return;

//       const selectedLevel = designationInputs.find(input => input.name === "designationlevel")
//         ?.options.find(option => option.value === formData.designationlevel)?.label;
// console.log("selectedLevel",selectedLevel);
//       if (selectedLevel === "level 1") {
//         setRequired(false)
//         setShowParentDesignation(false);
//         const updatedInputs = designationInputs.map((input) =>
//           input.name === "parentDesignation" ? { ...input, options: [], isVisible: false } : input
//         );
    
//         setDesignationInputs(updatedInputs);
//         return;
//       }
//       else{
//         setRequired(true)
//       }

//       setShowParentDesignation(true);

//       try {

//         const payload = {
//           // hierarchy_level: 2,
//           hierarchy_level:designationLevelId
//         }
//         if (userType === "superadmin") {
//           payload.business_partner_id = formData.business_partner_id;
//         } else {
//           payload.business_partner_id = businessPartnerId;
//         }

//         const response = await axiosInstance.post(
//           "/designation/ddlparentdesignation",
//           payload,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${authToken}`,
//             }
//           }
//         );

//         const parentDesignationList = response.data.data.data.map(ParentDesignation => ({
//           label: ParentDesignation.NAME,
//           value: ParentDesignation.ID,
//         }));
        
//         const updatedInputs = designationInputs.map((input) =>
//           input.name === "parentDesignation" ? { ...input, options: parentDesignationList, isVisible: true } : input
//         );
//         setDesignationInputs(updatedInputs);
//       } catch (error) {
//         console.error("Error fetching parent designations:", error);
//       }
//     };

//     // fetchParentDesignations();

//     if (formData.designationlevel){
//       const parentDesignationId = formData.designationlevel;

//       if (parentDesignationId){
//         fetchParentDesignations(parentDesignationId)
//       }
//     }

//   }, [formData.designationlevel, authToken]);

  const handleFormSubmit = async (data) => {
    console.log(formData, "FORMDATA");
    const errors = {};
    let isValid = true;
  
    DesignationInputsTemplate.forEach((field) => {
      if (field.required && !data[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(data[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this designation?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
  
          const payload = {
            hierarchy_level: data.designationlevel,
            parent_designation_id:data.designationlevel>1? data.parentDesignation:null,
            designation_name: data.designationName,
            designation_desc: data.description,
            status: data.status === "Active" ? 1 : 0,
          };
  
          if (userType === "superadmin") {
            payload.business_partner_id = data.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
  
          await axiosInstance.post(
            "/designation/create",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              }
            }
          );
          Swal.fire({
            title: "Success",
            text: "Designation added successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate(ROUTES_NAVIGATION.DESIGNATIONLIST); 
          });
  
        } catch (error) {
          const errorMessage = error.response?.data?.message || "Failed to add designation. Please try again.";
          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          console.error("Error adding designation:", error);
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "Designation addition cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };
  

  // useEffect(() => {
    
  // },[])

  // const userTypedropdown = async () => {
  //   try{
  //     const response = await axiosInstance.get("/bp-onboard/bplist",{
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     })

  //     const userTypeOptions = response.data.data.data.map(user => ({
  //       label:user.bp_name,
  //     value: user.onboard_id,
  //     }));

  //     setDesignationInputs((prevInputs) =>
  //       prevInputs.map((input) =>
  //         input.name === "business_partner_id" ? { ...input, options: userTypeOptions, isVisible: true } : input
  //       )
  //     );


  //   }catch(error) {
  //     console.log(error)
  //   }
  // }

  return (
    <>
     <div>
    {loading ? (
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Add New Designation</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Designation Details
                </span>
                <DynamicForm
                  formConfig={DesignationInputsTemplate}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  onSubmit={handleFormSubmit}
                  // showParentDesignation={showParentDesignation} 
                  />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit(formData);
                  } }
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
    )}
    </div>
    </>
  );
};

export default AddNewDesignation;
